import React, { useState } from "react";

import AppNavBar from "./app_pages/app_components/_NavBar";
import AppFooter from "./app_pages/app_components/_Footer";
import AppSidebar from "./app_pages/app_components/_Sidebar";

const Layout = (props: any) => {
  const { children } = props;
  const [sidebar, setSidebar] = useState<Boolean>(true);
  const [display, setDisplay] = useState<String>("none");
  const [hideSidebar, setHideSidebar] = useState<String>("0");
  return (
    <>
      <AppSidebar
        sidebar={sidebar}
        setSidebar={setSidebar}
        hideSidebar={hideSidebar}
        setHideSidebar={setHideSidebar}
      >
        <AppNavBar
          sidebar={sidebar}
          setSidebar={setSidebar}
          display={display}
          setDisplay={setDisplay}
          hideSidebar={hideSidebar}
          setHideSidebar={setHideSidebar}
        />
        {children}
        <AppFooter />
      </AppSidebar>
    </>
  );
};

export default Layout;
